import Axios from 'axios'
import { getCategoryChildren, getCategoryExclusives, getCategoryParents, getCategoryRoot, postCustomItemRequest } from '@/api/category'

const axiosSource = {
  children: undefined,
  parents: undefined,
  exclusives: undefined,
}

const category = {
  namespaced: true,
  state: () => ({
    status: {
      rootCategory: {
        initialized: false,
        refreshing: false,
        error: false,
      },
      children: {
        initialized: false,
        refreshing: false,
        error: false,
      },
      parents: {
        initialized: false,
        refreshing: false,
        error: false,
      },
      exclusives: {
        initialized: false,
        refreshing: false,
        error: false,
      },
    },
    rootCategory: {
      id: undefined,
      name: '',
    },
    children: [],
    parents: [],
    exclusives: [],
    currentCategoryId: undefined,
  }),
  getters: {
    // getCategoryRoot: (state) => state.root,
    // isCategoryRootLoaded: (state) => state.status === 'success',
    // getCategoryChildren: (state) => state.children,
    // isCategoryChildrenLoaded: (state) => state.status === 'success',
    // getCategoryParents: (state) => state.parents,
    // isCategoryParentsLoaded: (state) => state.status === 'success',
  },
  actions: {
    fetchRootCategory ({
      commit,
      dispatch,
      state
    }) {
      return new Promise((resolve, reject) => {
        // TODO only allow to check the root once?
        commit('SET_REFRESHING_TRUE', 'rootCategory')
        commit('SET_ERROR_FALSE', 'rootCategory')
        getCategoryRoot()
          .then((category) => {
            commit('SET_INITIALIZED_TRUE', 'rootCategory')
            commit('SET_REFRESHING_FALSE', 'rootCategory')
            commit('SET_ROOT_CATEGORY', category)
            resolve()
            if (state.currentCategoryId === undefined) {
              dispatch('setCurrentCategoryId', category.id)
            }
          })
          .catch((err) => {
            commit('SET_REFRESHING_FALSE', 'rootCategory')
            commit('SET_ERROR_TRUE', 'rootCategory')
            reject(err)
          })
      })
    },
    fetchChildren ({ commit }, categoryId) {
      return new Promise((resolve, reject) => {
        commit('SET_REFRESHING_TRUE', 'children')
        commit('SET_ERROR_FALSE', 'children')
        if (axiosSource.children) {
          axiosSource.children.cancel()
        }
          axiosSource.children = Axios.CancelToken.source()

        getCategoryChildren(categoryId, axiosSource.children.token)
          .then((children) => {
            commit('SET_INITIALIZED_TRUE', 'children')
            commit('SET_REFRESHING_FALSE', 'children')
            commit('SET_CHILDREN_CATEGORIES', children)
            resolve()
          })
          .catch((err) => {
            commit('SET_REFRESHING_FALSE', 'children')
            commit('SET_ERROR_TRUE', 'children')
            reject(err)
          })
      })
    },
    fetchParents ({ commit }, categoryId) {
      return new Promise((resolve, reject) => {
        commit('SET_REFRESHING_TRUE', 'parents')
        commit('SET_ERROR_FALSE', 'parents')
        if (axiosSource.parents) {
          axiosSource.parents.cancel()
        } else {
          axiosSource.parents = Axios.CancelToken.source()
        }
        getCategoryParents(categoryId, axiosSource.parents.token)
          .then((parents) => {
            commit('SET_INITIALIZED_TRUE', 'parents')
            commit('SET_REFRESHING_FALSE', 'parents')
            commit('SET_PARENT_CATEGORIES', parents)
            resolve()
          })
          .catch((err) => {
            commit('SET_REFRESHING_FALSE', 'parents')
            commit('SET_ERROR_TRUE', 'parents')
            reject(err)
          })
      })
    },
    fetchExclusives ({ commit }) {
      return new Promise((resolve, reject) => {
        commit('SET_REFRESHING_TRUE', 'exclusives')
        commit('SET_ERROR_FALSE', 'exclusives')
          axiosSource.exclusives = Axios.CancelToken.source()
        getCategoryExclusives(axiosSource.exclusives.token)
          .then((exclusives) => {
            commit('SET_INITIALIZED_TRUE', 'exclusives')
            commit('SET_REFRESHING_FALSE', 'exclusives')
            commit('SET_EXCLUSIVE_CATEGORIES', exclusives)
            resolve()
          })
          .catch((err) => {
            commit('SET_REFRESHING_FALSE', 'exclusives')
            commit('SET_ERROR_TRUE', 'exclusives')
            reject(err)
          })
      })
    },
    addCustomItemRequest ({ commit }, customItem) {
      return new Promise((resolve, reject) => {
        postCustomItemRequest(customItem)
          .then(() => {
            resolve()
          })
      })
    },
    setCurrentCategoryId ({
      commit,
      dispatch
    }, categoryId) {
      return new Promise((resolve, reject) => {
        commit('SET_CURRENT_CATEGORY_ID', categoryId)
        resolve()
        dispatch('fetchParents', categoryId)
        dispatch('fetchChildren', categoryId)
      })
    }
  },
  mutations: {
    SET_INITIALIZED_TRUE: (state, dataName) => {
      state.status[dataName].initialized = true
    },
    SET_REFRESHING_TRUE: (state, dataName) => {
      state.status[dataName].refreshing = true
    },
    SET_REFRESHING_FALSE: (state, dataName) => {
      state.status[dataName].refreshing = false
    },
    SET_ERROR_TRUE: (state, dataName) => {
      state.status[dataName].error = true
    },
    SET_ERROR_FALSE: (state, dataName) => {
      state.status[dataName].error = false
    },
    SET_ROOT_CATEGORY: (state, payload) => {
      state.rootCategory = payload
    },
    SET_EXCLUSIVE_CATEGORIES: (state, payload) => {
      state.exclusives = payload
    },
    SET_PARENT_CATEGORIES: (state, payload) => {
      state.parents = payload
    },
    SET_CHILDREN_CATEGORIES: (state, payload) => {
      state.children = payload
    },
    SET_CURRENT_CATEGORY_ID: (state, payload) => {
      state.currentCategoryId = payload
    },
  },
}

export default category
